import { type TenantBrandingColors } from "../types";

export const branding: TenantBrandingColors = {
  backgroundColor: "#F2F2F3",
  sidebar: {
    sidebarBackgroundColor: "#0c0c0c",
    sidebarColor: "#ffffff",
    sidebarBorderColor: "rgba(214, 220, 225, 0.2)",
  },

  auth: {
    authBackgroundColor: { light: "#0c0c0c", dark: "#0c0c0c" },
    authColor: "#ffffff",
    authBorderColor: "rgba(214, 220, 225, 0.2)",
  },

  brandDefault: {
    light: "#4B6CD1",
    dark: "#4B6CD1",
  },
  brandHover: {
    light: "#3B56A9",
    dark: "#3B56A9",
  },
  brandActive: {
    light: "#4B6CD1",
    dark: "#4B6CD1",
  },
  brandOpacity: {
    light: "rgba(19, 25, 110, 0.2)",
    dark: "rgba(19, 25, 110, 0.2)",
  },
  dataColors: {
    light: ["#4B6CD1", "#BBC9ED", "#5B5B5B", "#C8C8C8", "#ECD362"],
    dark: ["#4B6CD1", "#BBC9ED", "#5B5B5B", "#C8C8C8", "#ECD362"],
  },
};
